import { useOrderFlowContext } from '@euler/app/flows/order/OrderFlowContext';
import { Icon } from '@euler/components/Icomoon';
import { PredefinedHitSlops } from '@euler/functions/predefinedHitSlops';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';

export const HeaderRight = memo(({ onAdd }: { onAdd?: () => void }) => {
  const { showCustomServiceSubjectModal$ } = useOrderFlowContext();
  const { rpx } = useResponsiveContext();
  const handleAdd = useCallback(() => {
    showCustomServiceSubjectModal$.next(true);
    onAdd?.();
  }, [onAdd, showCustomServiceSubjectModal$]);
  return (
    <TouchableOpacity onPress={handleAdd} hitSlop={PredefinedHitSlops.large}>
      <Icon name="plus" size={rpx(20)} color="#fff" />
    </TouchableOpacity>
  );
});
